import { useEffect, useState } from "react";
import Loader from "../components/loader";
import PieceList from "../components/piece/pieceList";

import { Helmet } from "react-helmet";
import { useAppContext } from "../context/appContext";
import { MainPageResponseDTO } from "../openapi-generated-client";
import "./discoverPage.css";

export default function DiscoverPage() {

    const {sessionId, pageController} = useAppContext();

    const [data, setData] = useState<MainPageResponseDTO>();

    async function fetchData() {
        setData((await pageController.getMainPage(sessionId)).data);
    }

    useEffect(() => {
        fetchData();
    }, []);



    if(data == undefined) {
        return <Loader/>;
    }

    return <div className="page keep-margin minHeight100">

        <Helmet>
            <title>Discover | Txoria</title>
        </Helmet>
        {data.forYou && <div className="discover-section">
            <h2>For You</h2>
            <PieceList pieces={data.forYou} displayProps={{
                linkPrefix: "/pieces"
            }}/>
        </div>}
        <div className="discover-section">
            <h2>Most recent</h2>
            <PieceList pieces={data.newest} displayProps={{
                linkPrefix: "/pieces"
            }}/>
        </div>

    </div>;

}